import { awardsSectionData } from "@/mocks/homeData";
import AnimatedSection from "@/components/AnimatedSection";

export default function AwardsSection() {
  return (
    <section className="py-20 md:py-28 bg-background-50 relative overflow-hidden">
      {/* Subtle background decoration */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gradient-to-br from-[#2563EB]/3 via-[#7C3AED]/3 to-[#F97316]/3 rounded-full blur-3xl pointer-events-none" />

      <div className="container-astro relative z-10">
        <AnimatedSection>
          <div className="text-center mb-14 md:mb-18">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 mb-4 font-heading tracking-tight">
              {awardsSectionData.heading}
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto leading-relaxed mb-5">
              {awardsSectionData.subtext}
            </p>
            <div className="w-16 h-1 rounded-full mx-auto bg-gradient-to-r from-[#2563EB] via-[#7C3AED] to-[#F97316]" />
          </div>
        </AnimatedSection>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 max-w-5xl mx-auto">
          {awardsSectionData.items.map((item, i) => (
            <AnimatedSection key={item.title} delay={i * 120}>
              <div className="group relative p-7 md:p-8 rounded-2xl bg-background-100 border border-background-200/60 hover:border-accent-300/30 hover:shadow-lg hover:shadow-accent-500/5 transition-all duration-400 card-lift text-center h-full">
                {/* Top accent line */}
                <div
                  className="absolute inset-x-0 top-0 h-[3px] rounded-t-2xl transition-all duration-300 group-hover:h-[4px]"
                  style={{
                    background: `linear-gradient(90deg, ${item.color}, ${item.color}88)`,
                  }}
                />

                {/* Icon circle with brand color */}
                <div
                  className="w-14 h-14 flex items-center justify-center rounded-2xl mx-auto mb-5 transition-transform duration-300 group-hover:scale-105"
                  style={{
                    background: `${item.color}15`,
                    border: `1px solid ${item.color}25`,
                  }}
                >
                  <span
                    className="w-7 h-7 flex items-center justify-center"
                    style={{ color: item.color }}
                  >
                    <i className={`${item.icon} text-xl`} />
                  </span>
                </div>

                {/* Year badge */}
                <div
                  className="inline-flex items-center px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider mb-3"
                  style={{
                    background: `${item.color}12`,
                    color: item.color,
                  }}
                >
                  {item.year}
                </div>

                <h3 className="text-base font-bold text-foreground-950 mb-2 font-heading">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}